import { useContext, useEffect, useState } from "react";
import { apiGateway } from "../utils/config";
import useStore from "../store/UseStore";
import useAxiosPrivate from "./useAxiosPrivate";
import { Context } from "../store";

// Alternate Hook which will fetch the user details and store it in zustand store globally,
// when in use, just call the hook and access the data from the useStore
const useUserInformation = ({ setUser }) => {
  const { userData, setUserData } = useStore();
  const [isLoggedIn, setIsLoggedIn] = useState(null);
  const axiosPrivate = useAxiosPrivate();
  const globalState = useContext(Context);

  const handleGetUserDetails = async () => {
    try {
      const url = `${apiGateway}/api/v1/users/me/`;
      const response = await axiosPrivate.get(url);
      if (response?.data) {
        if (setUser) setUser(response?.data);
        setUserData(response?.data?.user);
        globalState?.addUserInformation(response?.data);
      }
    } catch (error) {
      console.log("ERROR", error.message);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      try {
        const storedIsLoggedIn = localStorage.getItem("isLoggedIn");
        setIsLoggedIn(storedIsLoggedIn);
      } catch (error) {
        console.log("Failed to access localStorage:", error);
      }
    }
  }, []);

  useEffect(() => {
    if (isLoggedIn === "true" && userData === null) {
      handleGetUserDetails(); // calling the API only when userData is null from zustand store
    }
  }, [isLoggedIn, userData]);
};

export default useUserInformation;
